var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSadEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "183.6 289 244.21 214.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 183.601562 289 L 427.808594 289 L 427.808594 503.398438 L 183.601562 503.398438 Z M 183.601562 289 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(42.349243%,45.489502%,47.839355%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 37.999694 39.999709 C 40.000107 42.999959 42.999958 44.000298 47.000014 44.000298 C 45.559717 42.569821 44.000164 39.630035 44.000164 37.000223 C 44.000164 35.089859 44.930356 32.760073 45.649735 31.139784 C 46.63994 28.920211 47.000014 26.529961 47.000014 23.999647 C 47.000014 12.959949 36.710197 3.999761 23.99988 3.999761 C 11.290333 3.999761 0.999746 12.959949 0.999746 23.999647 C 0.999746 35.04011 11.290333 44.000298 23.99988 44.000298 C 27.569848 44.000298 30.969781 43.240285 33.999637 41.999621 ",
    transform: "matrix(5.077076,0,0,5.10374,183.599993,273.812819)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(42.349243%,45.489502%,47.839355%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 19.999824 17.000338 C 19.999824 18.657364 18.6557 19.999823 16.999973 19.999823 C 15.344247 19.999823 14.000123 18.657364 14.000123 17.000338 ",
    transform: "matrix(5.077076,0,0,5.10374,183.599993,273.812819)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(42.349243%,45.489502%,47.839355%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 33.999637 17.000338 C 33.999637 18.657364 32.656283 19.999823 30.999787 19.999823 C 29.344061 19.999823 27.999937 18.657364 27.999937 17.000338 ",
    transform: "matrix(5.077076,0,0,5.10374,183.599993,273.812819)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(42.349243%,45.489502%,47.839355%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 30.999787 30.999722 C 27.132835 26.998367 20.866926 27.002194 16.999973 30.999722 ",
    transform: "matrix(5.077076,0,0,5.10374,183.599993,273.812819)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadEmoji);
export default __webpack_public_path__ + "static/media/sad-emoji.98a44d3a.svg";
export { ForwardRef as ReactComponent };